// ------------------------------------------ Marquee Card Slider Start

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const marqueeSliders = document.querySelectorAll(".marquee-main-slider");
    marqueeSliders.forEach(function (slider) {
      const flickityInstance = new Flickity(slider, {
        accessibility: true,
        resize: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        percentPosition: true,
        setGallerySize: true,
      });

      flickityInstance.x = 0.0;
      let requestId;
      const defaultSpeed = 0.75;
      let currentSpeed = defaultSpeed;
      let targetSpeed = defaultSpeed;

      function play() {
        currentSpeed += (targetSpeed - currentSpeed) * 0.1;
        flickityInstance.x -= currentSpeed;
        flickityInstance.settle(flickityInstance.x);
        requestId = window.requestAnimationFrame(play);
      }

      play();

      function slowDown() {
        targetSpeed = defaultSpeed * 0.3;
      }

      function speedUp() {
        targetSpeed = defaultSpeed;
      }

      slider.addEventListener("mouseenter", slowDown);
      slider.addEventListener("mouseleave", speedUp);
      slider.addEventListener("focusin", slowDown);
      slider.addEventListener("focusout", speedUp);
    });
  }, 1000);

  // ------------------------------------------ GIF Slider Start

  const sliders = document.querySelectorAll(".gif-slider");

  sliders.forEach((slider) => {
    const sectionId = slider.getAttribute("data-section-id");
    const slides = slider.querySelectorAll(`.gif-slider-slide-${sectionId}`);
    const sliderContainer = slider.querySelector(".gif-slider-container");
    const sliderSpeed =
      parseInt(slider.getAttribute("data-slider-speed")) * 1000;
    const transitionSpeed =
      parseInt(slider.getAttribute("data-transition-speed")) * 1000;
    const isClickable = slider.getAttribute("data-clickable") === "true";

    let currentIndex = 0;
    const slideCount = slides.length;

    function goToNextSlide() {
      let nextIndex = (currentIndex + 1) % slideCount;

      slides[nextIndex].style.zIndex = 2;
      slides[nextIndex].classList.add("active");

      slides[currentIndex].style.zIndex = 1;

      setTimeout(() => {
        slides[currentIndex].classList.remove("active");
        currentIndex = nextIndex;
      }, transitionSpeed);
    }

    setInterval(goToNextSlide, sliderSpeed + transitionSpeed);

    if (isClickable) {
      sliderContainer.style.cursor = "pointer";
      sliderContainer.addEventListener("click", goToNextSlide);
    }
  });

  // ------------------------------------------ Side Tab Opener

  const tabButtons = document.querySelectorAll(".tab-button-container span");

  const overlay = document.createElement("div");
  overlay.classList.add("tab-overlay");
  document.body.appendChild(overlay);

  tabButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const tabId = this.id;

      const tabContainer = document.querySelector(
        `.side_tab_container#${tabId}`
      );

      document
        .querySelectorAll(".side_tab_container.open")
        .forEach((openTab) => {
          openTab.classList.remove("open");
        });

      if (tabContainer) {
        tabContainer.classList.add("open");
        overlay.classList.add("active");
      }
    });
  });

  overlay.addEventListener("click", function () {
    document.querySelectorAll(".side_tab_container.open").forEach((openTab) => {
      openTab.classList.remove("open");
    });
    overlay.classList.remove("active");
  });
}); //JS End
